module.exports = __webpack_public_path__ + "793eac8e296086bc76dac1c80fd5a40d.png";


//////////////////
// WEBPACK FOOTER
// ./web/images/logos/brand-logo-google.png
// module id = 633
// module chunks = 0